<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Gallery'}">
              <h4 class="ms-2">
                {{label.pages.gallery}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.galleryInfo}}
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-tabs
              nav-class="tab-title"
              active-nav-item-class="tab-title-active"
              fill
              justified
              pills
          >
            <b-tab active>
              <template #title>
                {{label.pages.pictures}}
              </template>
              <gallery-image />
            </b-tab>
            <b-tab>
              <template #title>
                {{label.pages.video}}
              </template>
              <gallery-video />
            </b-tab>
            <b-tab>
              <template #title>
                {{label.pages.audio}}
              </template>
              <gallery-sound />
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import galleryImage from '@/views/pages/gallery/Image'
import galleryVideo from '@/views/pages/gallery/Video'
import gallerySound from '@/views/pages/gallery/Sound'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'ManageGallery',
  data(){
    return{
      label,
    }
  },
  components: {
    galleryImage,
    galleryVideo,
    gallerySound,
  }
}
</script>
